import type { User } from '../types/User';

export const getFullName = (
  employee?:
    | {
        firstName?: User['firstName'] | null | undefined;
        lastName?: User['lastName'] | null | undefined;
      }
    | null
    | undefined
) => {
  return employee
    ? [employee?.firstName, employee?.lastName].filter(Boolean).join(' ')
    : '';
};
